import { createSlice } from "@reduxjs/toolkit";
import { getFacilities } from "./thunk";
import { PaginationResponse, ResponseData } from "api/types/_public";
import { IFacility } from "api/types/_facility";

export interface IState {
  facilities: ResponseData<IFacility[]> & PaginationResponse | null,
  isFacilitiesLoading: boolean,
  isFacilitiesSuccess: boolean,

  error: any,
};

export const initialState: IState = {
  facilities: null,
  isFacilitiesLoading: false,
  isFacilitiesSuccess: false,

  error: {},
};

const FacilitySlice = createSlice({
  name: "facility",
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    //get Categories
    builder.addCase(getFacilities.pending, (state: IState, action: any) => {
      state.isFacilitiesLoading = true
    });
    builder.addCase(getFacilities.fulfilled, (state: IState, action: any) => {
      state.facilities = action.payload.data;
      state.isFacilitiesSuccess = true;
      state.isFacilitiesLoading = false;
    });
    builder.addCase(getFacilities.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isFacilitiesSuccess = false;
      state.isFacilitiesLoading = false;
    });
  },
});

export default FacilitySlice.reducer;